import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useProfileFactorySausageCardStyles = makeStyles((theme) =>
  createStyles({
    card: {
      flex: 1,
      display: 'flex',
      padding: '16px 18px 20px 16px',
      [theme.breakpoints.down('sm')]: {
        padding: '24px 16px'
      },
      [theme.breakpoints.down('xs')]: {
        padding: '14px 0 0',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.12)'
      }
    },

    premium: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '5px 9px',
      backgroundColor: '#F2C94C',
      borderTopLeftRadius: 4,
      borderBottomRightRadius: 4,
      [theme.breakpoints.down('xs')]: {
        padding: '1px 3px 1px 5px'
      }
    },

    premiumTitle: {
      color: '#fff',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: 12,
      [theme.breakpoints.down('xs')]: {
        fontSize: 10
      }
    },

    cardLef: {
      display: 'flex',
      justifyContent: 'center'
    },

    defaultImg: {
      display: 'grid',
      placeItems: 'center',
      width: 92,
      height: 92,
      borderRadius: '50%',
      background: '#C4C4C4',
      color: '#fff',
      fontSize: 40,
      fontWeight: 500,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down('md')]: {
        fontSize: 20
      }
    },

    avatarImage: {
      width: 92,
      height: 92,
      borderRadius: '50%',
      objectFit: 'cover'
    },

    specialistInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: 40
    },

    reviews: {
      padding: 0,
      textAlign: 'center',
      fontFamily: 'Roboto',
      textTransform: 'none',
      fontSize: 16
    },

    reviewsCount: {
      fontWeight: 400
    },

    name: {
      marginTop: 15,
      flex: 1,
      maxWidth: 300,
      fontFamily: 'Roboto',
      fontSize: 18,
      textAlign: 'left',
      color: '#212121',
      [theme.breakpoints.down('sm')]: {
        height: 50
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 16
      }
    },

    specialization: {
      margin: '17px 10px 0 50px',
      flex: 2,
      textAlign: 'left',
      fontFamily: 'Roboto',
      fontSize: 14,
      maxWidth: 300,
      color: '#757575',
      [theme.breakpoints.down('xs')]: {
        fontSize: 12
      }
    },

    cardContainer: {
      marginTop: 15,
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },

    cardButton: {
      height: 44,
      width: 174,
      padding: 0,
      border: '1px solid #E64147',
      letterSpacing: '1.25px',
      fontSize: 12,
      textDecoration: 'none',
      color: '#E64147',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    cardTop: {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        zIndex: 2,
        display: 'block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: '#24C034',
        border: '4px solid #fff',
        bottom: 0,
        left: '65%',
        boxSizing: 'content-box'
      }
    }
  })
)
